import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-types-badge',
  templateUrl: './payment-types-badge.component.html',
  styleUrls: ['./payment-types-badge.component.css']
})
export class PaymentTypesBadgeComponent implements OnInit {

  @Input() value: string;
  constructor() { }

  ngOnInit(): void {
  }


}
